import { render, staticRenderFns } from "./EAutoCompleteCommodity.vue?vue&type=template&id=7856eb84"
import script from "./EAutoCompleteCommodity.vue?vue&type=script&lang=js"
export * from "./EAutoCompleteCommodity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7856eb84')) {
      api.createRecord('7856eb84', component.options)
    } else {
      api.reload('7856eb84', component.options)
    }
    module.hot.accept("./EAutoCompleteCommodity.vue?vue&type=template&id=7856eb84", function () {
      api.rerender('7856eb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EAutoCompleteCommodity.vue"
export default component.exports